import axios from 'axios';
import ServerProperties from '../config/server.js'

export default {
  ReadByWork: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get( 
      params.data.url === undefined ? ServerProperties.ATM_CLOUD.API+ 'Maintenance/Reminder/Work/' + params.data.query+ '/' : params.data.url,
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  },
  Register: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Reminder/Register/', 
      params.data.field
    )
    .then(function(response) {
      params.onsuccess(params, response)
    })
    .catch(error => {
      if (error.response) {
        
        if(error.response.data.hasOwnProperty('Email')) {
          params.onfailed(error.response.data.Email[0])
        } else if(error.response.data.hasOwnProperty('Time')) {
          params.onfailed('Datetime has wrong format')
        } else {
          params.onfailed(error.response.data.detail)
        }

      } else if (error.request) {
        params.onfailed(error.request)

      } else {
        console.log("Error :" + error.message);
      }
    });
  },
  Update: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Reminder/Update/' + params.data.alias + '/', 
      params.data.field
    )
    .then(function(response) {
      params.onsuccess(params, response)
    })
    .catch(error => {
      params.onfailed(error)
    });
  },
}


// WEBPACK FOOTER //
// ./src/App/remainder/model.js